import { c as _c } from "react/compiler-runtime";
import { IconCross, IconTick } from '@newfront-insurance/core-ui';
// eslint-disable-next-line no-restricted-imports
import { cn } from '@newfront-insurance/core-ui/v2';
import { useEffect, type JSX } from 'react';
import { useNotifications } from '../context';
import { DEFAULT_ERROR_DURATION, DEFAULT_SUCCESS_DURATION } from '../lib/duration';
import type { Notification } from '../types';
interface Props {
  id: string;
  notification: Notification;
}
export function NotificationItem(props) {
  const $ = _c(25);
  const {
    id,
    notification
  } = props;
  const {
    title,
    type
  } = notification;
  const defaultDuration = type === "error" ? DEFAULT_ERROR_DURATION : DEFAULT_SUCCESS_DURATION;
  const {
    duration: t0
  } = notification;
  const duration = t0 === undefined ? defaultDuration : t0;
  const notifications = useNotifications();
  let t1;
  let t2;
  if ($[0] !== duration || $[1] !== id || $[2] !== notifications) {
    t1 = () => {
      if (duration <= 0) {
        return _temp;
      }
      const timeout = setTimeout(() => notifications.remove(id), duration);
      return () => {
        clearTimeout(timeout);
      };
    };
    t2 = [duration, id, notifications];
    $[0] = duration;
    $[1] = id;
    $[2] = notifications;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = type === "success" && "bg-grass-400";
  const t4 = type === "error" && "bg-fire-500";
  const t5 = type !== "success" && type !== "error" && "bg-[#042553]";
  let t6;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = cn("shadow-floating-bar relative mb-2 flex max-w-[400px] min-w-[300px] items-center rounded-xs p-4 pr-10 whitespace-pre-line text-white", t3, t4, t5);
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== type) {
    t7 = type === "success" && <IconTick size={16} />;
    $[9] = type;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== id || $[12] !== notifications || $[13] !== type) {
    t8 = type === "error" && <button type="button" onClick={() => notifications.remove(id)} className="flex items-center justify-center rounded-sm p-1 hover:bg-white/20 focus:ring-2 focus:ring-white/50 focus:outline-hidden" aria-label="Dismiss notification" data-testid="notification-dismiss"><IconCross color="#ffffff" size={16} /></button>;
    $[11] = id;
    $[12] = notifications;
    $[13] = type;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `text-center break-words text-white ${type === "success" || type === "error" ? "text-sm leading-[18px]" : "text-base leading-[21px]"}`;
  let t10;
  if ($[15] !== t9 || $[16] !== title) {
    t10 = <span className={t9} data-testId="notification-text">{title}</span>;
    $[15] = t9;
    $[16] = title;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8) {
    t11 = <div className="flex w-full flex-row items-center gap-4" data-testId="notification-box">{t7}{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t6) {
    t12 = <div className={t6}>{t11}</div>;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp() {}